import { render, staticRenderFns } from "./ListVendorPage.vue?vue&type=template&id=793a5a29&"
import script from "./ListVendorPage.vue?vue&type=script&lang=js&"
export * from "./ListVendorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports